import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';

(() => {
    const blocks = document.querySelectorAll('[data-anchor-partners]');

    const options = {
        arrows: false,
        classes: {
            pagination: 'splide__pagination',
            page: 'splide__pagination__page',
        },
        focus: 0,
        type: 'loop',
        height: '152px',
        perPage: 5,
        perMove: 1,
        gap: '80px',
        lazyLoad: 'nearby',
        preloadPages: 1,
        grid: {
            rows: 2,
            gap: {
                row: '24px',
            },
        },
        breakpoints: {
            1024: {
                perPage: 4,
                height: '152px',
                gap: '80px',
                lazyLoad: 'nearby',
                preloadPages: 1,
                grid: {
                    rows: 2,
                    gap: {
                        row: '24px',
                    },
                },
            },
            768: {
                perPage: 3,
                height: '152px',
                gap: '80px',
                lazyLoad: 'nearby',
                preloadPages: 1,
                grid: {
                    rows: 2,
                    gap: {
                        row: '24px',
                    },
                },
            },
            640: {
                height: '136px',
                perPage: 2,
                lazyLoad: 'nearby',
                preloadPages: 0,
                gap: '20px',
                grid: {
                    gap: {
                        row: '16px',
                    },
                },
            },
        },
    };

    for (let block of blocks) {
        const splide = new Splide(block.querySelector('.splide-partners'), options);
        window.addEventListener('load', () => splide.mount({ Grid }));
    }
})();
